// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__XW-Vv","avatar":"style_avatar__1tsh5"};